
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/[urlname]",
      function () {
        return require("private-next-pages/explore/[urlname].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/[urlname]"])
      });
    }
  